<template>
  <div
    class="trainer-street-btns trastrbtns"
    :class="{ trastrbtns_loading: loading }"
  >
    <div
      v-for="item in streets"
      :key="item.street_id"
      class="trastrbtns_street"
      :class="[
        { 'opacity_5 no-events': item.disabled },
        {
          trastrbtns_street_active: spotStreet === item.street_id,
        },
      ]"
      @click="handleStreetClick(item)"
    >
      <div class="trastrbtns_street_title">
        <i
          v-if="item.correctness ? item.correctness.correctness_group.icon : false"
          class="mdi trastrbtns_street_title_icon"
          :class="[item.correctness.correctness_group.icon]"
          :style="`color: var(${item.correctness.correctness_group.color})`"
        />
        {{ $t(`common.${item.street_id}`) }}
      </div>
      <!-- <div
        class="trastrbtns_street_score"
        v-if="item.correctness ? !item.correctness.street_na : false"
      >
        {{ numFixed(item.correctness.avg_gto_score * 100) }}%
      </div> -->
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import { all_streets } from '@/helpers/constants'

export default {
  name: 'TrainerStreetBtns',
  mixins: [format_mix],
  props: {
    namespace: { String, required: true },
    loading: Boolean,
    spot: Object,
    historyHand: Object,
    hasSounds: Boolean,
  },
  methods: {
    handleStreetClick(item) {
      // console.log(item)
      const spot_id = item.correctness.worst_spot_id
      this.$store.dispatch(`${this.namespace}/trainer_auto_new_hand_stop`)
      this.$store.dispatch('poker_replay_spot', {
        namespace: this.namespace,
        spot_id,
        hasSounds: this.hasSounds,
      })
    },
    handleGGClick() {
      this.$store.dispatch('poker_replay_spot', {
        namespace: this.namespace,
        lastSpot: true,
        hasSounds: this.hasSounds,
      })
    },
  },
  computed: {
    spotStreet() {
      if (!this.spot) return ''

      const enabledStreets = this.streets.filter(i => !i.disabled)
      let street = enabledStreets.find(i => i.street_id === this.spot.street)
      if (!street) {
        street = enabledStreets[enabledStreets.length - 1]
      }
      return street?.street_id
    },
    streets() {
      const res = all_streets.map(i => {
        const street = (this.historyHand?.correctness?.streets || []).find(s => s.street_id === i)
        return {
          street_id: i,
          ...(street || {}),
          disabled: !street,
        }
      })
      // console.log(res, this.historyHand)
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.trastrbtns {
  transition: 0.22s;
  display: flex;
  flex-wrap: wrap;
  grid-gap: 0.125em;
  min-height: 2em;
  &_as-nav {
    display: flex !important;
    flex-wrap: nowrap;
    overflow: auto;

    .trastrbtns_street_score {
      display: none;
    }
    .trastrbtns_street {
      flex: 1;
    }
  }
  &_loading {
  }
  &_street {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.22s;
    padding: 0 0.75em;
    // min-height: 2.35rem;
    // min-height: 2.25em;

    border-radius: 4px;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.875em;
    flex-shrink: 0;

    --clr-card-primary: var(--clr-hero);
    --clr-card-back: var(--clr-black-2);
    --clr-card-back-hover: var(--clr-black-2);
    --clr-title: var(--clr-grey-3);
    --clr-title-hover: var(--clr-card-primary);

    --clr-border: transparent;
    --clr-border-hover: var(--clr-card-primary);
    --border-width: 2px;

    background: var(--clr-card-back);
    border: solid var(--border-width) var(--clr-border);
    &_title {
      display: flex;
      align-items: center;
      justify-content: center;
      &_icon {
        margin: 0 0.5em 0 0;
        font-size: 1.25em;
      }
    }
    &_score {
      margin-left: 0.5em;
    }
    &_active {
      border: solid 2px var(--clr-primary);
    }
  }
}
@media (max-width: 1435px) {
  .trastrbtns {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
@media (hover: hover) and (pointer: fine) {
  .trastrbtns {
    &_street {
      &:hover {
        cursor: pointer;
        --clr-card-back: var(--clr-card-back-hover);
        --clr-title: var(--clr-title-hover);
        --clr-border: var(--clr-border-hover);
      }
    }
  }
}
</style>
